import { render } from "./confirmarPedido.vue?vue&type=template&id=781bb45e&scoped=true"
import script from "./confirmarPedido.vue?vue&type=script&lang=js"
export * from "./confirmarPedido.vue?vue&type=script&lang=js"

import "./confirmarPedido.vue?vue&type=style&index=0&id=781bb45e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781bb45e"]])

export default __exports__